// @ts-ignore
/* eslint-disable */
// API 更新时间：
// API 唯一标识：
import * as analysis from "./analysis";
import * as average from "./average";
import * as cart from "./cart";
import * as classes from "./classes";
import * as classUpload from "./classUpload";
import * as exam from "./exam";
import * as feedback from "./feedback";
import * as grade from "./grade";
import * as gradeUpload from "./gradeUpload";
import * as paperQuestionScore from "./paperQuestionScore";
import * as papers from "./papers";
import * as paperUpload from "./paperUpload";
import * as questionBankPapers from "./questionBankPapers";
import * as questionScoreUpload from "./questionScoreUpload";
import * as quickAdmin from "./quickAdmin";
import * as school from "./school";
import * as scoreLineUpload from "./scoreLineUpload";
import * as student from "./student";
import * as studentUpload from "./studentUpload";
import * as teacher from "./teacher";
import * as teacherUpload from "./teacherUpload";
import * as tp from "./tp";
import * as user from "./user";
import * as wrongQuestion from "./wrongQuestion";
export default {
  analysis,
  average,
  classUpload,
  classes,
  exam,
  feedback,
  papers,
  grade,
  gradeUpload,
  paperQuestionScore,
  paperUpload,
  questionBankPapers,
  questionScoreUpload,
  quickAdmin,
  school,
  scoreLineUpload,
  student,
  studentUpload,
  teacher,
  teacherUpload,
  tp,
  user,
  cart,
  wrongQuestion,
};
